import React from "react";
import Seo from "../components/Seo";
import { PrimaryButton } from "../components/Buttons";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page not found — Velacin"
        description="The page you're looking for doesn't exist."
        path="/404"
      />
      <section className="grid min-h-screen place-items-center bg-black px-6">
        <div className="text-center" data-testid="not-found">
          <div
            className="text-gradient-blue text-7xl font-extrabold tracking-tight sm:text-8xl"
            style={{ WebkitTextFillColor: "transparent" }}
          >
            404
          </div>
          <h1 className="mt-6 text-2xl font-bold text-white sm:text-3xl">
            This page went off-board.
          </h1>
          <p className="mx-auto mt-4 max-w-md text-sm text-white/60">
            The page you're looking for doesn't exist — or it shipped somewhere
            else. Let's get you back on track.
          </p>
          <div className="mt-8 flex justify-center">
            <PrimaryButton to="/" testId="notfound-home">
              Back to home
            </PrimaryButton>
          </div>
        </div>
      </section>
    </>
  );
}
